import {
  AggregationLevel,
  EnergyPowerApiResponse,
} from '@energybox/react-ui-library/dist/types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTSEnergyByEquipmentId } from '../../actions/energyTS';
import { ApplicationState } from '../../reducers';

const useGetEquipmentEnergy = (
  equipmentId: number,
  fromDateTimestampInSeconds: number | undefined,
  toDateTimestampInSeconds: number | undefined,
  aggregationLevel: AggregationLevel,
  idAffix?: string
) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (fromDateTimestampInSeconds && toDateTimestampInSeconds) {
      dispatch(
        getTSEnergyByEquipmentId(
          equipmentId,
          {
            from: fromDateTimestampInSeconds,
            to: toDateTimestampInSeconds,
            aggregationLevel,
            seeSpilloverPoint: true,
          },
          idAffix
        )
      );
    }
  }, [
    equipmentId,
    aggregationLevel,
    fromDateTimestampInSeconds,
    toDateTimestampInSeconds,
    idAffix,
    dispatch,
  ]);

  const equipmentEnergy = useSelector<
    ApplicationState,
    EnergyPowerApiResponse | undefined
  >(({ energy }) => {
    const updatedEquipmentId = idAffix ? equipmentId + idAffix : equipmentId;
    return energy.energyByEquipmentId[updatedEquipmentId] as
      | EnergyPowerApiResponse
      | undefined;
  });

  return equipmentEnergy;
};

export default useGetEquipmentEnergy;
